import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AdminAuthProvider } from '@/contexts/AdminAuthContext';
import './index.css';

const queryClient = new QueryClient();

// Import the generated route tree
import { routeTree } from './routeTree.gen';

// Create a new router instance
const router = createRouter({ routeTree });

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error(
    "Root element not found. Check if it's in your index.html or if the id is correct."
  );
}

// Render the app
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <ErrorBoundary>
        <HelmetProvider>
          <TooltipProvider>
            <QueryClientProvider client={queryClient}>
              <AdminAuthProvider>
                <RouterProvider router={router} />
                <Toaster position="top-right" richColors closeButton />
              </AdminAuthProvider>
            </QueryClientProvider>
          </TooltipProvider>
        </HelmetProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
